import PropTypes from 'prop-types';

import Tag from '#globalComponents/Tag/Tag';

import { describeNonOperatingRole } from '../../utils/companyKinds';

// `className` wraps the tag, e.g. to cap its width inside a table cell.
const CompanyKindBadge = ({ company, vocabulary, size = 'sm', className }) => {
	const badge = describeNonOperatingRole(company, vocabulary);
	if (!badge) return null;
	const tag = <Tag label={badge.label} title={badge.title} tone={badge.tone} size={size} />;
	return className ? <span className={className}>{tag}</span> : tag;
};

CompanyKindBadge.propTypes = {
	company: PropTypes.shape({
		isOperating: PropTypes.bool,
		nonOperatingRole: PropTypes.string,
		operatingCompanyName: PropTypes.string,
	}).isRequired,
	vocabulary: PropTypes.object,
	size: PropTypes.oneOf(['xs', 'sm']),
	className: PropTypes.string,
};

export default CompanyKindBadge;
